/*
 * @Author: Dong
 * @Date: 2022-04-16 17:04:27
 * @LastEditors: Dong
 * @LastEditTime: 2022-04-25 16:33:11
 */
interface statusStateType {
  visible: boolean;
  type: string; // install 安装  upgrade 升级
  disabled: boolean;
}

const statusReducer = (state: statusStateType, action: { type: string; params?: any }) => {
  const { type, params = {} } = action;

  switch (type) {
    // 显隐Modal
    case 'toggleVisible':
      return {
        ...state,
        visible: !state.visible,
      };
    // 点击操作按钮
    case 'clickBtn':
      return {
        ...state,
        visible: !state.visible,
        type: params.type,
      };
    // 允许操作Modal确认按钮
    case 'btnActive':
      return {
        ...state,
        disabled: params.disabled,
      };
    // 清除状态
    case 'clearType':
      return {
        ...state,
        type: '',
        visible: false,
        disabled: true,
      };
    default:
      return { ...state };
  }
};

const initStatus: statusStateType = {
  visible: false,
  type: '',
  disabled: true,
};

export { statusReducer, initStatus };
